import { queryKeys } from "../queryKeys";
import {
  getOwnerDocuments,
  type OwnerDocument,
} from "../rest/entityOnboarding";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOwnerDocuments = ({
  accountId,
  ownerId,
  options,
}: {
  accountId: string;
  ownerId: string;
  options?: QueryOptions<OwnerDocument[]>;
}) => {
  const { data, refetch } = useRequest(
    queryKeys.documents.ownerDocuments(accountId, ownerId),
    () => getOwnerDocuments(accountId, ownerId),
    {
      refetchInterval: false,
      enabled: !!ownerId && !!accountId,
      ...options,
    },
  );

  return { documents: data ?? [], refetch };
};

export default useGetOwnerDocuments;
